import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { gameAPI } from '../utils/api';
import { toast } from 'react-toastify';
import './Home.css';

const Home = () => {
  const { user } = useAuth();
  const [upcomingGames, setUpcomingGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadUpcomingGames();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadUpcomingGames = async () => {
    try {
      const response = await gameAPI.getAllGames();
      if (response.success) {
        // Nur die nächsten 3 Spiele anzeigen
        // Ausgeblendete Fahrten gehoeren auch fuer den Vorstand nicht auf die
        // oeffentlichen Seiten - die API liefert sie Admins mit aus.
        const sortedGames = response.games
          .filter(game => game.visible !== 0 && game.visible !== false)
          .sort((a, b) => new Date(a.game_date) - new Date(b.game_date))
          .slice(0, 3);
        setUpcomingGames(sortedGames);
      }
    } catch (error) {
      console.error('Fehler beim Laden der Spiele:', error);
      toast.error('Fehler beim Laden der Spiele');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home">
      <div className="container">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <h1>Willkommen beim EFC Buseck</h1>
            {!user ? (
              <div className="hero-actions">
                <Link to="/registrieren" className="btn btn-primary">
                  Jetzt registrieren
                </Link>
                <Link to="/login" className="btn btn-secondary">
                  Anmelden
                </Link>
              </div>
            ) : (
              <div className="hero-actions">
                <Link to="/spiele" className="btn btn-primary">
                  Spiele ansehen
                </Link>
              </div>
            )}
          </div>
        </section>

        {/* Upcoming Games - Nur für eingeloggte User */}
        {user && (
          <section className="upcoming-games">
            <h2>Nächste Spiele</h2>
            {loading ? (
              <div className="loading">
                <p>Spiele werden geladen...</p>
              </div>
            ) : (
              <div className="games-grid">
                {upcomingGames.length === 0 ? (
                  <div className="no-games">
                    <p>Derzeit sind keine Spiele geplant.</p>
                  </div>
                ) : (
                  upcomingGames.map(game => (
                    <div key={game.id} className="game-card">
                      <h3>{game.opponent}</h3>
                      <div className="game-details">
                        <p><strong>Datum:</strong> {new Date(game.game_date).toLocaleDateString('de-DE')}</p>
                        <p><strong>Uhrzeit:</strong> {game.game_time}</p>
                        <p><strong>Ort:</strong> {game.location}</p>
                      </div>
                      <div className="game-actions">
                        <Link to={`/spiel/${game.id}`} className="btn btn-primary">
                          Details ansehen
                        </Link>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}

            <div className="view-all">
              <Link to="/spiele" className="btn btn-secondary">
                Alle Spiele ansehen
              </Link>
            </div>
          </section>
        )}

      </div>
    </div>
  );
};

export default Home;
